module.exports = __webpack_public_path__ + "static/img/instagram.2c4b17bd.svg";